import { useTheme } from '@mui/material';
import { RHFDatePicker } from '@talentmesh/forms';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

interface CustomRHFDatePickerProps {
    name: string;
    label: string;
    placeholder?: string | false;
    disabled?: boolean;
}

const CustomRHFDatePicker: React.FC<CustomRHFDatePickerProps> = ({ name, label, placeholder, disabled }) => {
    const theme = useTheme();
    const { setValue } = useFormContext();

    useEffect(() => {
        if (disabled) {
            setValue(name, null);
        }
    }, [disabled]);

    return (
        <RHFDatePicker
            name={name}
            label={`${label}*`}
            views={['month', 'year']}
            disableFuture
            slotProps={{
                textField: {
                    placeholder: placeholder || undefined,
                    fullWidth: true,
                    style: {
                        backgroundColor: disabled
                            ? theme.palette.action.disabledBackgroundLight
                            : theme.palette.common.white,
                        borderRadius: theme.spacing(1),
                    },
                },
            }}
            disabled={disabled}
        />
    );
};

export default CustomRHFDatePicker;
